export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Semibold.d7eb561eee88a713a5da96b683d639b7.woff2";